PJQ.views.primeContracts.ChangeOrderEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PRIMECONTRACTS, 'modal-change-order-edit'),
        width: '95%',
        maxWidth: 1500,
        model: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .btn-view-prime-contract': 'viewPrimeContract',
        'click .btn-add-line-item': 'addLineItem',
        'click .btn-save-email': 'saveEmail',
        'click .btn-save': 'saveChangeOrder',
        'click .btn-push-erp': 'pushERP',
        'click .btn-undo-push-erp': 'undoPushERP',
        'click .btn-unlink-erp': 'unlinkERP',
        'click .btn-delete': 'deleteChangeOrder',
        'click .btn-close': 'close',
        'click .btn-export': 'exportChangeOrder',
        'click .btn-export-markup': 'exportChangeOrderWithMarkup',
        'click .btn-email': 'email',
        'click .nav-link': 'activeViewChanged',
        'click .btn-copy-markups': 'copyMarkups',
        'click .btn-view-history': 'viewHistory'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;

        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;
        this.coreFieldSettings = await this.options.project.fetchPrimeContractChangeOrderFieldSettings();
        this.settings = await this.options.project.fetchPrimeContractChangeOrderSettings();
        this.customFields = await this.options.project.fetchPrimeContractChangeOrderCustomFields();
        this.costCodes = await this.options.project.fetchCostCodes();
        this.costTypes = await this.options.project.fetchCostTypes();
        this.unitsOfMeasure = await this.options.project.fetchUnitsOfMeasure();

        if (this.model == null) {
            let customFieldValues = [];
            _.each(this.customFields.models, function (model, index) {
                let value = model.get('defaultValue') ? model.get('defaultValue') : '';
                if (model.get('fieldType') === 'CHOICE') {
                    value = parseInt(value);
                }
                customFieldValues.push({
                    fieldNumber: model.get('fieldNumber'),
                    fieldTypeId: model.get('fieldTypeId'),
                    fieldType: model.get('fieldType'),
                    isMultiple: model.get('isMultiple'),
                    value: value,
                    id: model.get('id')
                })
            }, this);

            this.model = new PJQ.models.primeContracts.ChangeOrder({
                description: '',
                primeContractId: this.options.primeContract.id,
                primeContractNumber: this.options.primeContract.get('number'),
                client: this.options.primeContract.client,
                clientId: this.options.primeContract.clientId,
                accountingMethod: this.options.primeContract.get('accountingMethod'),
                projectId: this.options.primeContract.get('projectId'),
                statusId: PJQ.constants.primeContracts.changeOrderStatus.DRAFT,
                lineItems: this.options.lineItems,
                customFieldValues: customFieldValues
            });
        }

        if (!this.model.isNew()) {
            await this.model.fetch();
        }

        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();
        if (this.erpIntegration != null && this.erpIntegration.getSetting('syncProjects')) {
            await this.options.project.fetchERPObject();
        }

        if (this.options.primeContract == null) {
            this.options.primeContract = new PJQ.models.primeContracts.PrimeContract({
                id: this.model.get('primeContractId') ?? this.options.primeContract?.id
            });
        }

        if (!this.options.primeContract.isFetched) {
            await this.options.primeContract.fetch();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.canEdit = this.options.project.hasPermission('primeContractChangeOrders.canEdit');
        this.options.canEditLineItems = this.options.canEdit;
        this.options.canViewPrimeContracts = this.options.project.hasPermission('primeContractChangeOrders.canView');
        this.options.isAdmin = this.options.project.hasPermission('primeContractChangeOrders.isAdmin');
        this.options.canDelete = this.options.isAdmin;
        this.options.canEditStatus = this.options.isAdmin;

        this.options.disabledStatuses = null;
        let fnGetGreaterStatuses = (statusId) => {
                return _.filter(PJQ.constants.commitments.commitmentStatus, (st) => {
                    return st < statusId;
                });
            },
            status = this.model.get('statusId');
        if (status === PJQ.constants.primeContracts.changeOrderStatus.DRAFT) {
            this.options.canEdit = true;
        } else if (status === PJQ.constants.primeContracts.changeOrderStatus.APPROVED
            || status === PJQ.constants.primeContracts.changeOrderStatus.REJECTED
            || status === PJQ.constants.primeContracts.changeOrderStatus.VOID) {
            this.options.canEditLineItems = false;
            this.options.canEdit = this.options.project.hasPermission('primeContractChangeOrders.canEdit');
            this.options.canDelete = false;
        } else {
            this.options.canEdit = this.options.project.hasPermission('primeContractChangeOrders.canEdit');
            this.options.canEditLineItems = this.options.canEdit;
            this.options.canDelete = this.options.isAdmin;
        }

        if (this.model.invoices.models.length > 0) {
            this.options.disabledStatuses = fnGetGreaterStatuses(PJQ.constants.primeContracts.changeOrderStatus.APPROVED);
            this.options.canEditLineItems = false;
        }

        if (!this.options.isAdmin && this.settings.get('isMarkupAdmin') === true) {
            this.options.canEditLineItems = false;
        }

        if (this.erpIntegration != null) {
            let syncStatus = this.model.erpSyncStatus();
            if (syncStatus === PJQ.constants.integrations.erp.syncStatuses.REVIEWING
                || syncStatus === PJQ.constants.integrations.erp.syncStatuses.APPROVED
                || syncStatus === PJQ.constants.integrations.erp.syncStatuses.SYNCED
            ) {
                this.options.disabledStatuses = fnGetGreaterStatuses(PJQ.constants.primeContracts.changeOrderStatus.APPROVED);
                this.options.canEdit = false;
                this.options.canEditLineItems = false;
                this.options.canDelete = false;
            }
        }
    },
    renderData: function () {
        return {
            model: this.model,
            customFields: this.customFields,
            erpIntegration: this.erpIntegration,
            canEditLineItems: this.options.canEditLineItems,
            canEdit: this.options.canEdit,
            canDelete: this.options.canDelete,
            isAdmin: this.options.isAdmin,
            canViewPrimeContracts: this.options.canViewPrimeContracts,
            isFetched: this.isFetched,
            activeView: this.options.activeView,
            views: this.views,
            checkFieldVisible: _.bind(this.checkFieldVisible, this),
            checkFieldRequired: _.bind(this.checkFieldRequired, this),
            unCopiedMarkupsCount: _.size(this.getUnCopiedMarkups())
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.activateView(this.options.activeView);

        this.stopListening(this.model.markupItems);
        this.listenTo(this.model.markupItems, 'update', (markup) => {
            if(markup && markup.get('delete') && (markup.lineItem || markup.get('lineItemId'))){
                let lineItem = markup.lineItem ?? this.model.lineItems.findWhere({appliedMarkupId: markup.id});

                if(lineItem){
                    if(lineItem.get('id') > 0){
                        lineItem.set('delete', true);
                    } else {
                        this.model.lineItems.remove(lineItem);
                    }
                }
            }

            this.updateCounts();
            this.lineItemsView.render();
        });

        this.stopListening(this.model);
        this.listenTo(this.model, 'change:statusId', () => {
            this.renderERP();
        });
        this.stopListening(this.model.lineItems);
        this.listenTo(this.model.lineItems, 'update', () => {
            this.renderERP();
        });
        this.renderERP();

        this.renderGeneral();
        this.renderLineItems();
        this.renderMarkups();

        this.updateCounts();
    },
    updateCounts: function () {
        this.$('.count-line-items').text(_.size(_.filter(this.model.lineItems.models, (item) => {
            return !item.get('delete');
        })));
        this.$('.count-markups').text(_.size(_.filter(this.model.markupItems.models, function (item) {
            return !item.get('delete');
        })));
    },
    views: {
        GENERAL: 'PCCO_General',
        LINEITEMS: 'PCCO_LineItems',
        CHANGEORDERS: 'PCCO_ChangeOrders',
        INVOICES: 'PCCO_Invoices',
        PAYMENTS: 'PCCO_Payments',
        MARKUPS: 'PCCO_Markups'
    },
    activeViewChanged: function (e) {
        let view = e.target.hash ? e.target.hash.replace('#', '') : null;
        this.activateView(view);
    },
    activateView: function (view) {
        if (view == null) {
            view = this.views.GENERAL;
        }

        this.$('.nav-link[href="#' + view + '"]').tab('show');
        this.options.activeView = view;

        if (view === this.views.LINEITEMS) {
            // this.lineItemsView.adjustColumns();
        }
    },
    getUnCopiedMarkups: function () {
        if (this.model == null || this.model.markupItems == null
            || this.options.primeContract == null || this.options.primeContract.markupItems == null) {
            return [];
        }

        return _.filter(this.options.primeContract.markupItems.models, (contractMarkup) => {
            return !_.some(this.model.markupItems.models, (markup) => {
                return markup.get('percent') === contractMarkup.get('percent')
                    && markup.get('name') === contractMarkup.get('name')
                    && markup.get('isVertical') === contractMarkup.get('isVertical')
                    && markup.get('isCompounding') === contractMarkup.get('isCompounding');
            });
        });
    },
    copyMarkups: function () {
        let maxSort = 1;
        if (_.size(this.model.markupItems.models) > 0) {
            maxSort = _.max(this.model.markupItems.models, (markup) => {
                return markup.get('sortOrder');
            });
        }
        _.each(this.getUnCopiedMarkups(), (markup) => {
            let copiedMarkup = new PJQ.financialMarkups.models.FinancialMarkup({
                percent: markup.get('percent'),
                name: markup.get('name'),
                isVertical: markup.get('isVertical'),
                isCompounding: markup.get('isCompounding'),
                costCodeIds: markup.get('costCodeIds'),
                costTypeIds: markup.get('costTypeIds'),
                appliedCostCodeId: markup.get('appliedCostCodeId'),
                appliedCostTypeId: markup.get('appliedCostTypeId'),
                isApplied: markup.get('isApplied'),
                sortOrder: ++maxSort,
                isDirty: true
            });

            this.model.markupItems.add(copiedMarkup);
            if(copiedMarkup.get('appliedCostCodeId') && copiedMarkup.get('appliedCostTypeId')){
                this.model.markupItems.trigger('appliedMarkupChanged', copiedMarkup);
            }
        });
        this.render();
    },
    renderMarkups: function () {
        if (!this.options.isAdmin) {
            return;
        }

        this.markupsView = new PJQ.financialMarkups.views.FinancialMarkupsList({
            el: this.$('.pcco-markups'),
            collection: this.model.markupItems,
            canEdit: this.options.canEditLineItems
        });
    },
    renderERP: function () {
        let $erp = this.$('.erp-sync'),
            syncPrimeContracts = this.erpIntegration && (this.erpIntegration.getSetting(PJQ.constants.integrations.settings.SYNC_PRIME_CONTRACTS) || this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_CONTRACT_CO_WITHOUT_PRIME_CONTRACT)),
            syncChangeOrders = this.erpIntegration && this.erpIntegration.getSetting(PJQ.constants.integrations.settings.SYNC_PRIME_CONTRACT_CHANGE_ORDERS);
        if (!this.options.isAdmin || this.erpIntegration == null || !this.options.project.isERPSynced()
            || (syncChangeOrders !== true && (syncPrimeContracts !== true && syncChangeOrders !== false))) {
            $erp.remove();
            return;
        }

        let canPush = true,
            disablePushReason = "";
        if (_.size(this.model.lineItems) === 0
            || (this.model.get('statusId') !== PJQ.constants.primeContracts.changeOrderStatus.APPROVED)) {
            canPush = false;
            disablePushReason = "Change Order must be approved and have line items";
        }

        if (!this.options.primeContract.isERPSynced() && !this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_CONTRACT_CO_WITHOUT_PRIME_CONTRACT)) {
            canPush = false;
            disablePushReason = "The contract for this change order is not synced";
        }

        PJQ.helpers.erp.renderERPButtons(this.$('.erp-sync'), {
            status: this.model.erpSyncStatus(),
            pushSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_PRIME_CONTRACT_CHANGE_ORDERS),
            canPush: canPush,
            canPushChanges: false,
            disablePushReason: disablePushReason,
            unlinkSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.UNLINK_PRIME_CONTRACT_CHANGE_ORDERS)
        });
    },
    pushERP: function (callback) {
        if (!this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_PRIME_CONTRACT_CHANGE_ORDERS)) {
            return;
        }

        this.save((success) => {
            if (success) {
                this.erpIntegration.pushPrimeContractChangeOrder(this.model, () => {
                    PJQ.notifications.notify.successNotify({
                        message: 'Contract Change Order pushed to ERP'
                    });

                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }

                    if (callback && typeof callback === 'function') {
                        callback();
                    } else {
                        this.render();
                    }
                });
            }
        });
    },
    undoPushERP: function () {
        if (this.model.erpSyncStatus() === PJQ.constants.integrations.erp.syncStatuses.REVIEWING) {
            this.erpIntegration.undoPush(this.model, () => {
                PJQ.notifications.notify.successNotify({
                    message: 'Contract Change Order removed from ERP approval'
                });

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                this.render();
            });
        }
    },
    unlinkERP: function () {
        new PJQ.views.modals.YesNo({
            header: "Unlink from ERP",
            body: "Are you sure you want to unlink this Contract Change Order from your ERP system?",
            onYes: () => {
                let loader = new PJQ.Loader(this.$('.modal-content'));
                this.erpIntegration.unlinkPrimeContractChangeOrder(this.model, _.bind(function (success) {
                    if (success) {
                        loader.remove();
                        PJQ.notifications.notify.successNotify({
                            message: 'Contract Change Order unlinked from ERP'
                        });

                        if (typeof this.options.onSave === 'function') {
                            this.options.onSave(this.model);
                        }

                        this.render();
                    }
                }, this));
            }
        });
    },
    renderGeneral: function () {
        new PJQ.Binder(this.$el, this.model, {
            canEdit: !this.options.canEdit ? false : null,
            useDecimalPercentFields: true,
            watchElements: [
                'input',
                'textarea'
            ]
        });

        let choices = _.map(PJQ.constants.primeContracts.changeOrderStatus, (st) => {
            return {
                id: st,
                name: PJQ.constants.primeContracts.changeOrderStatusNames[st],
                disabled: this.options.disabledStatuses != null && this.options.disabledStatuses.indexOf(st) > -1
            }
        });
        this.statusPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-status'),
            choices: choices,
            defaultValue: this.model.get('statusId') != null ? this.model.get('statusId') : 2,
            canEdit: this.options.canEditStatus,
            isMultiple: false,
            isIntChoices: true,
            onChange: _.bind(function (newStatus) {
                let oldStatus = this.model.get('statusId');
                if (newStatus === oldStatus) {
                    return;
                }

                this.model.set('statusId', newStatus);
                if (!this.model.isNew()) {
                    this.save((success) => {
                        if (success) {
                            PJQ.notifications.notify.successNotify({
                                message: 'Contract Change Order saved successfully'
                            });
                        } else {
                            this.model.set('statusId', oldStatus);
                            this.statusPicker.setValue(oldStatus);
                        }
                    });
                } else {
                    this.render();
                }
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.change-order-due-date'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('dueDate')
            },
            onChange: _.bind(function (newDate) {
                this.model.set('dueDate', newDate);
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.change-order-invoiced-date'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('invoicedDate')
            },
            onChange: _.bind(function (newDate) {
                this.model.set('invoicedDate', newDate);
            }, this)
        });

        this.clientPicker = new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.contract-client'),
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            selectedContact: this.model.client,
            isSingleChoice: true,
            canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
            canEdit: false,
            onChange: _.bind(function (selectedContact) {
                this.model.client = selectedContact;
                this.model.set('clientId', selectedContact ? selectedContact.id : 0);
            }, this)
        });

        this.reviewerPicker = new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.change-order-reviewer'),
            selectedContact: this.model.reviewer,
            canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
            shouldHideContacts: true,
            canEdit: this.options.canEdit,
            displayContactsBlock: true,
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            isSingleChoice: true,
            onChange: _.bind(function (selectedContact) {
                this.model.reviewer = selectedContact;
                this.model.set('reviewerId', selectedContact ? selectedContact.id : null);
            }, this)
        });

        this.receivedFromPicker = new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.change-order-received-from'),
            selectedContact: this.model.receivedFrom,
            canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
            canEdit: this.options.canEdit,
            displayContactsBlock: true,
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            isSingleChoice: true,
            onChange: _.bind(function (selectedContact) {
                this.model.receivedFrom = selectedContact;
                this.model.set('receivedFromId', selectedContact ? selectedContact.id : null);
            }, this)
        });

        if (_.size(this.customFields) > 0) {
            this.customFieldsForm = new PJQ.views.customFields.CustomFieldsForm({
                el: this.$('.change-order-custom-fields'),
                isEdit: this.options.canEdit,
                isAdmin: this.options.isAdmin,
                collection: this.customFields,
                fieldValues: this.model.get('customFieldValues'),
                onChange: _.bind(function () {
                    this.model.isDirty = true;
                }, this)
            });
        }

        if (this.checkFieldVisible('attachments')) {
            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.cco-file-uploader'),
                collection: this.model.attachments,
                canUpload: this.options.canEdit,
                useApiV2: true,
                canView: false,
                canDelete: this.options.isAdmin,
                previewImageDimension: 150,
                onSuccess: _.bind(function (file) {
                    this.model.isDirty = true;
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.get('id') > 0) {
                        attachment.set('delete', true);
                    } else {
                        attachment.destroy();
                    }

                    this.model.isDirty = true;
                    callback();
                }, this)
            });
        }
    },
    renderLineItems() {
        if(this.lineItemsView){
            this.lineItemsView.remove();
        }

        this.lineItemsView = new PJQ.views.budget.LineItemsView({
            el: this.$('.cco-line-items'),
            collection: this.model.lineItems,
            lineItemModel: PJQ.models.primeContracts.ChangeOrderLineItem,
            accountingMethod: this.model.get('accountingMethod'),
            canEdit: this.options.canEditLineItems,
            canDelete: this.options.canEditLineItems,
            primeContractId: this.model.get('primeContractId'),
            financialMarkups: this.model.markupItems,
            showMarkup: this.options.isAdmin || this.settings.get('isMarkupAdmin') !== true,
            enableTax: true,
            showBilling: this.model.get('statusId') === PJQ.constants.primeContracts.changeOrderStatus.APPROVED,
            showSubTotal: true,
            showGrandTotal: true,
            onAccountingMethodChanged: _.bind(function (value) {
                this.model.set('accountingMethod', value);
            }, this),
            onLineItemChange: _.bind(function () {
                this.model.isDirty = true;
            }, this),
            onLineItemAdd: _.bind(function () {
                this.model.isDirty = true;
                this.updateCounts();
            }, this),
            onLineItemDelete: _.bind(function () {
                this.model.isDirty = true;
                this.updateCounts();
            }, this)
        });
    },
    viewPrimeContract: function () {
        this.removeModal();
        new PJQ.views.primeContracts.PrimeContractEditModal({
            model: new PJQ.models.primeContracts.PrimeContract({
                id: this.model.get('primeContractId')
            })
        });
    },
    checkFieldVisible: function (fieldName) {
        if (this.coreFieldSettings) {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isVisible');
            }
        }
        return true;
    },
    checkFieldRequired: function (fieldName) {
        if (this.coreFieldSettings) {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isRequired');
            }
        }
        return false;
    },
    viewHistory: async function () {
        let historyItems = [{
            date: this.model.get('createdOn'),
            person: this.model.get('createdBy'),
            action: 'Change Order Created'
        }];

        let history = new PJQ.collections.primeContracts.ChangeOrderHistory({}, {
            changeOrderId: this.model.id
        });
        new PJQ.views.history.HistoryTimelineModal({
            collection: history,
            subTitle: 'Contract Change Order #' + this.model.get('number'),
            items: historyItems
        });
    },
    exportChangeOrder: function (withMarkup = false) {
        let params = [];
        if (withMarkup === true) {
            params.push({
                parameter: 'withMarkup',
                value: true
            });
        }

        let callback = _.bind(function () {
            PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'primecontractchangeorders',
                    value: this.model.get('id')
                },
                {
                    endpoint: 'export',
                }
            ], params), {isAPIv2: true});
        }, this);

        if (this.options.canEdit && this.model.hasChanged()) {
            this.save(callback);
        } else {
            callback();
        }
    },
    exportChangeOrderWithMarkup: function () {
        this.exportChangeOrder(true);
    },
    validate: function () {
        let isValid = true;

        if (this.customFieldsForm != null && !this.customFieldsForm.validate())
            isValid = false;

        PJQ.helpers.inputHelpers.setInputError(this.$('.input-number'), true);
        if ((!this.model.isNew() || this.checkFieldRequired('number')) && _.size(this.model.get('number')) === 0) {
            isValid = false;
            PJQ.helpers.inputHelpers.setInputError(this.$('.input-number'), false);
        }

        if (this.checkFieldRequired('reviewer')) {
            if (!this.reviewerPicker.validate()) {
                isValid = false;
            }
        }

        if (this.checkFieldRequired('receivedFromId')) {
            if (!this.receivedFromPicker.validate()) {
                isValid = false;
            }
        }

        if (this.checkFieldRequired('changeReason')) {
            let $changeReason = this.$('.change-reason');
            PJQ.helpers.inputHelpers.setInputError($changeReason, true);
            if (_.size(this.model.get('changeReason')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($changeReason, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('invoicedDate')) {
            let $invoicedDate = this.$('.change-order-invoiced-date');
            PJQ.helpers.inputHelpers.setInputError($invoicedDate, true);
            if (this.model.get('invoicedDate') == null || this.model.get('invoicedDate').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($invoicedDate, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('dueDate')) {
            let $dueDate = this.$('.change-order-due-date');
            PJQ.helpers.inputHelpers.setInputError($dueDate, true);
            if (this.model.get('dueDate') == null || this.model.get('dueDate').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($dueDate, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('description')) {
            let $description = this.$('.change-order-description');
            PJQ.helpers.inputHelpers.setInputError($description, true);
            if (_.size(this.model.get('description')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($description, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('attachments')) {
            this.fileUploader.clearError();
            let hasValidAttachment = _.find(this.model.attachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.fileUploader.showError('Missing attachment', 100000);
                isValid = false;
            }
        }

        if (!isValid) {
            this.activateView(this.views.GENERAL);
        }

        isValid = this.lineItemsView.validate();
        if (!isValid) {
            this.activateView(this.views.LINEITEMS);
        }

        if (!this.lineItemsView.validate()) {
            isValid = false;

            if (this.options.activeView !== 'lineItems') {
                this.options.activeView = 'lineItems';
                this.$('.nav-tabs a[href="#PCCO_LineItems"]').tab('show');
            }
        }

        return isValid;
    },
    saveEmail: function () {
        this.save((success) => {
            if (success) {
                PJQ.notifications.notify.successNotify({
                    message: 'Contract Change Order saved successfully'
                });

                this.email();
            }
        });
    },
    saveChangeOrder: function () {
        this.save((success) => {
            if (success) {
                PJQ.notifications.notify.successNotify({
                    message: 'Contract Change Order saved successfully'
                });
                this.removeModal()
            }
        });
    },
    save: function (callback, closeChangeOrder = true) {
        if (!this.validate()) {
            this.$('.modal').prevObject.scrollTop(0);
            if (typeof callback === 'function') {
                callback(false);
            }
            return;
        }

        let newMarkupLines = this.model.lineItems.filter(function (lineItem) {
            return lineItem.markup && lineItem.isNew();
        });
        this.model.lineItems.remove(newMarkupLines);

        this.model.save({
            reviewer: this.reviewer ? this.reviewer.toJSON() : null,
            receivedFrom: this.receivedFrom ? this.receivedFrom.toJSON() : null,
            lineItems: this.model.lineItems.toJSON()
        }, {
            success: () => {
                this.render();
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                this.options.project.trigger('contractCOChanged', this.model);
                if (typeof callback === 'function') {
                    callback(true);
                }
            },
            error: () => {
                if (typeof callback === 'function') {
                    callback(false);
                }
                PJQ.notifications.notify.errorNotify({
                    message: "Encountered an error while saving this Change Order. Please contact customer service."
                });
            }
        });
    },
    deleteChangeOrder: function () {
        let changeOrderId = this.model.id;
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this change order?",
            onDelete: _.bind(function () {
                this.model.destroy({
                    success: _.bind(function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'Change order deleted successfully'
                        });

                        if (typeof this.options.onDelete === 'function')
                            this.options.onDelete(changeOrderId);

                        this.removeModal();
                    }, this)
                });
            }, this)
        });
    },
    email: function () {
        let projectName = this.options.project?.get('projectName')?.trim();
        let subject = `A Change Order has been shared with you ${projectName && _.size(projectName) > 0 ? `for ${projectName}` : ''}`;
        new PJQ.views.email.ComposeEmailModal({
            header: "Email Contract Change Order",
            project: this.options.project,
            subject: subject,
            onSave: _.bind(function (data) {
                this.model.share(data, _.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: 'Contract Change Order email sent'
                    });
                }, this));
            }, this)
        });
    },
    close: function () {
        if (this.model.hasChanged() && this.options.canEdit) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.saveChangeOrder();
                    this.removeModal();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});